import React from 'react';

import { isSidebarSection } from './Sidebar.types';
import { SidebarDivider } from './SidebarDivider';
import { SidebarNavItem } from './SidebarNavItem';

import type { SidebarNavProps, SidebarNavItemData } from './Sidebar.types';

/**
 * Container component for sidebar navigation items.
 *
 * Renders navigation items and section dividers.
 */
export function SidebarNav({
  items,
  activeItemId,
  onItemClick,
  collapsed = false,
  className = '',
}: SidebarNavProps): React.JSX.Element {
  return (
    <nav
      className={`sidebar-nav flex flex-col gap-1 ${collapsed ? 'px-3' : 'px-2'} ${className}`}
      role="navigation"
      aria-label="Sidebar navigation"
    >
      {items.map((item) => {
        if (isSidebarSection(item)) {
          return (
            <SidebarDivider
              key={item.id}
              label={item.label ?? ''}
              collapsed={collapsed}
            />
          );
        }

        const navItem = item as SidebarNavItemData;
        const isActive = activeItemId === navItem.id;

        return (
          <SidebarNavItem
            key={navItem.id}
            item={navItem!}
            active={isActive}
            collapsed={collapsed}
            onClick={onItemClick!}
          />
        );
      })}
    </nav>
  );
}

export default SidebarNav;
